import React from 'react';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/clients/clients';
import { getItem } from 'src/reducers/common/itemReducer';
import selector, { getOptionLabel, display } from 'src/utils/Utils';
import { Item } from 'src/components/PrimaryPanel';
import { Dl, Dd, Dt } from 'src/components/SecondaryPanel';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { useTranslation } from 'react-i18next';

const BasicInfoSectionShow = ({ client, regions }) => {
  const { t, i18n } = useTranslation();
  const regionalTaxOfficeName = client.regionalTaxOfficeInformation?.name || '-';
  const managementTaxOfficeName = client.revenueOfficeInformation?.name || '-';
  const ssoOffficeName = client.ssoOfficeInfo ? (i18n.language === 'vi' ? client.ssoOfficeInfo.ssoOfficeName : client.ssoOfficeInfo.ssoOfficeNameEn) : '-';

  return (
    <Item>
      <Dl>
        <Dt>{t('features.Clients.components.BasicInfoSectionShow.viet_office_name')} :</Dt>
        <Dd>{client.name}</Dd>
      </Dl>
      <Dl>
        <Dt>{t('features.Clients.components.BasicInfoSectionShow.eng_office_name')} :</Dt>
        <Dd>{client.nameEng}</Dd>
      </Dl>
      <Dl>
        <Dt>{t('features.Clients.components.BasicInfoSectionShow.tax_identification_number')} :</Dt>
        <Dd>{client.corporateNumber}</Dd>
      </Dl>
      <Dl>
        <Dt>{t('features.Clients.components.BasicInfoSectionShow.social_security_number')} :</Dt>
        <Dd>{client.employerNumber}</Dd>
      </Dl>
      <Dl>
        <Dt>{t('features.Employees.components.BasicInfoSectionShow.Address')}</Dt>
        <Dd>{client.fullAddress}</Dd>
      </Dl>

      <Dl>
        <Dt>{t('features.Employees.components.BasicInfoSectionShow.Phone_number')}</Dt>
        <Dd>{client.telNumber}</Dd>
      </Dl>
      <Dl>
        <Dt>{t('features.Clients.components.BasicInfoSectionShow.owner_representative_name')}:</Dt>
        <Dd>
          {client.fullRepresentativeName}
        </Dd>
      </Dl>
      <Dl>
        <Dt>{t('features.Clients.components.BasicInfoSectionShow.regional_tax_office')}:</Dt>
        <Dd>{regionalTaxOfficeName}</Dd>
      </Dl>

      <Dl>
        <Dt>{t('features.Clients.components.BasicInfoSectionShow.management_tax_office')}:</Dt>
        <Dd>{managementTaxOfficeName}</Dd>
      </Dl>

      <Dl>
        <Dt>{t('features.Clients.components.BasicInfoSectionShow.thai_sso_office')}:</Dt>
        <Dd>{ssoOffficeName}</Dd>
      </Dl>

      <Dl>
        <Dt>{t('features.Clients.components.BasicInfoSectionShow.region')}:</Dt>
        <Dd>{display(getOptionLabel(client.region)(regions))}</Dd>
      </Dl>
    </Item>
  );
};

const mapStateToProps = state => ({
  client: selector(getItem(REDUCER_NAME, state), 'client') || {},
  regions: getSelectOptions(state, 'regions')
});

export default connect(mapStateToProps)(BasicInfoSectionShow);
